/*
 * Copyright (c) 2021-2024. StockAnywhere CC
 * StockAnywhere - https://www.stockanywhere.io
 * View license agreement and terms of use at https://www.stockanywhere.io/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2024-06-30
 */

import React, { ChangeEvent, useState } from "react";
import { useQueryListContext } from "./QueryListContext";


interface ListSearch {
    search: Map<string, string>;
    setSearch: React.Dispatch<React.SetStateAction<Map<string, string>>>;
    searchClicked: () => void;
    clearClicked: () => void;
}

export const ListSearch: React.FC<ListSearch> = (props) => {

    const {ctxData, getData, setData} = useQueryListContext();
    const [activeStatusKey, setActiveStatusKey] = useState<string | null>(null);
    
    const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
        if(event.target.type === 'text') {
            props.setSearch(prevSearch => {
                const newSearch = new Map(prevSearch);
                newSearch.set(event.target.id, event.target.value.trim());
                return newSearch;
            });
        }
    }


    const columns: React.ReactElement[] = [];
    let i: number = 0;
    const thStyle = {
        textWrap: 'nowrap',
        backgroundColor: 'white', //lightgray //white
        border: '1px solid #deebed',
        padding: '8px 4px',
    };

    const thControlsStyle = {
        textWrap: 'nowrap',
        backgroundColor: 'white', //lightgray
        border: '1px solid #deebed',
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        padding:'2px 0px',
        margin: '0px'

    };

    //change column names for display
    function transformString(inputString:string) {
        // Check if the input is a string
        if (typeof inputString !== 'string') {
            return inputString;
        }

        // Remove underscores and capitalize letters following each underscore
        const result = inputString
          .split('_') // Split the string by underscores
          .map((word, index) => {
            // Capitalize the first letter of each word after the first
            return index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1);
          })
          .join(' '); // Join all the words back together
      
        // Ensure the first letter is capitalized
        return result.charAt(0).toUpperCase() + result.slice(1);
    }

    //let skipCreatedUpdated = false;

    props.search.forEach((value: string, name: string) => {
        const placeholderName = transformString(name); 

        // Skip 'notifications.reference' column
        if (typeof name === "string" && name.toLowerCase() === "notifications.reference") {
            return;
        }

         // Skip 'id' column
        if (typeof name === "string" && name.toLowerCase() === "id") {
            return;
        }

       
        if (typeof name === "string" && name.toLowerCase() === "assets.url") {
            columns.push(
                <th key={i++} scope="col" style={thStyle} className="sa-search-control"></th>
            );
            return;
        }

        columns.push(
            <th key={i++} scope="col" style={thStyle} className="sa-search-control">
                <input id={name} name={name} onChange={handleOnChange} value={value} type="text" autoComplete="off" placeholder={`Search ${placeholderName}...`} className="form-control form-control-md" />
            </th>
        );
    });


    return(
        <>
            <thead className="sa-list-search">
                <tr id="searchBar" >          
                    {columns}                   
                    <th className="sa-search-control sa-export-selected-records" style={thControlsStyle}>
                        <button onClick={props.searchClicked} type="button" style={{border:'1px solid rgb(222, 235, 237)', backgroundColor: 'white', borderRadius: '5px', margin: '1px' }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#495057" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="" style={{width: '34px', height: '34px', margin: "0px", padding:"2px"}}>
                              <circle cx="11" cy="11" r="8"></circle>
                              <path d="m21 21-4.3-4.3"></path>
                           </svg>
                        </button>   
                        <button onClick={props.clearClicked} type="button" style={{ border:'1px solid rgb(222, 235, 237)', backgroundColor: 'white', borderRadius: '5px', margin: '1px' }}>
                             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#495057" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="" style={{width: '34px', height: '34px', margin: "0px"}}>
                                <path d="M18 6 6 18"></path>
                                <path d="m6 6 12 12"></path>
                             </svg>
                        </button> 
                    </th>
                </tr>
            </thead>
        </>
    );
}

